import pricing from '@/pricing'

const setCurrentUser = (state, payload) => {
  // eslint-disable-next-line global-require
  state.currentUser = {
    rememberSettings: {},
    ...payload,
  }
}

const setIsTokenValid = (state, payload) => {
  state.isTokenValid = payload
}

const setPlan = (state, payload) => {
  state.plan = pricing.getPlanByType(payload)
}

export default {
  setCurrentUser,
  setIsTokenValid,
  setPlan,
}
